<template>
  <div class="PersonVacationListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      <template v-slot:header.select="{}">
        <v-checkbox
          dense
          hide-details="true"
          v-model="isCheckAll"
          @change="checkAll()"
        ></v-checkbox>
      </template>
      <template v-if="show" v-slot:item.select="{ item }">
        <v-checkbox
          dense
          hide-details="true"
          v-model="item.select"
          @change="checkboxUpdated($event, item)"
          @click.stop=""
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    approved:Boolean,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      show:true,
      isCheckAll: false,
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "Perno",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("vacationType"),
          value: "Name",
        },
        {
          text: this.$t("BeginDate"),
          value: "BeginDate",
        },
        {
          text: this.$t("BeginTime"),
          value: "BeginTime",
        },
        {
          text: this.$t("EndDate"),
          value: "EndDate",
        },
        {
          text: this.$t("EndTime"),
          value: "EndTime",
        },
        {
          text: this.$t("status"),
          value: "StatusType",
        },
        {
          text: this.$t(""),
          value: "select",
        },
      ],
      
    };
  },
  mounted() {
    this.checkApproved();

  },
  methods: {
    checkAll() {
      var list = [...this.list];
      if (this.isCheckAll) {
        list.forEach((element) => {
          element.select = true;
        });
      } else {
        list.forEach((element) => {
          element.select = false;
        });
      }

      this.list = list;
    },
    handleClick(value) {
      this.$emit("onClickVacation", value);
    },
    checkboxUpdated(newValue, item) {
      console.log(newValue, item);
      //var num = this.selectedList.find(item)
      ////console.log(num);
    },
    checkApproved(){
      debugger
      if(this.approved){
        this.show=false;
        this.headers.splice(8)
      }
    },
      checkApprovedSelect(){
      debugger
      if(this.approved){
        this.show=false;
        debugger
       
       
      }
    },
    
  },
};
</script>

<style>
</style>